import React from 'react';

import {Sublabel} from 'ui-library/Headers';
import AddIcon from 'ui-library/icons/AddIcon';

interface ReviewCriteriaGroupHeaderProps {
  onAddCriterion: (() => void) | null; // If specified, renders a plus button
  renderControls?: () => boolean | JSX.Element;
  renderGroupName: () => string | JSX.Element;
  shouldRenderPassFail: boolean;
}

export default function ReviewCriteriaGroupHeader({
  onAddCriterion,
  renderControls,
  renderGroupName,
  shouldRenderPassFail,
}: ReviewCriteriaGroupHeaderProps): JSX.Element {
  return (
    <div className="simpleDivTable-header">
      <div className="simpleDivTable-headerCell">
        <div className="u-spacing-bottom">{renderGroupName()}</div>
        <div className="checkableCriterionRow-container">
          {shouldRenderPassFail && (
            <div className="checkableCriterionRow-passFail">
              <Sublabel>Pass</Sublabel>
            </div>
          )}
          {shouldRenderPassFail && (
            <div className="checkableCriterionRow-passFail u-small-spacing-right">
              <Sublabel>Fail</Sublabel>
            </div>
          )}
          <div className="checkableCriterionRow-text">
            <Sublabel>Criteria {onAddCriterion && <AddIcon onClick={onAddCriterion} />}</Sublabel>
          </div>
        </div>
      </div>
      <div className="simpleDivTable-headerCell u-text-align-right">{renderControls && renderControls()}</div>
    </div>
  );
}
